import { inject, Injectable, resource, computed } from '@angular/core';
import { TenancyContext } from '@core/tenancy';
import { HttpClient, HttpParams } from '@angular/common/http';

import { firstValueFrom } from 'rxjs';
import { environment } from '@environments/environment';

import { ResourceLinksType } from '@shared/enums';
import { ResourceLink } from '@shared/interfaces';
import { TenantFacadeService } from '@shared/features/tenant/shared/services/tenant-facade.service';

@Injectable()
export class CcsHelpResourceService {
  private readonly _http = inject(HttpClient);
  private readonly _tenancy = inject(TenancyContext);
  private readonly _tenantService = inject(TenantFacadeService);

  private readonly _helpLinks = resource({
    params: () => ({
      state: this._tenancy.stateCode(),
      prefix: this._tenantService.tenantApiPrefix(),
    }),
    loader: ({ params: { state, prefix } }) => {
      const { GUARDIAN, MINOR, PROBATE } = ResourceLinksType;

      let application: string;

      if (prefix === 'probates') {
        application = PROBATE;
      } else if (prefix === 'guardians') {
        application = GUARDIAN;
      } else {
        application = MINOR;
      }

      let params = new HttpParams();
      params = params.set('application', application);
      params = params.set('state', state);

      return firstValueFrom(
        this._http.get<ResourceLink[]>(
          `${environment.api}/courts/resource-links/`,
          { params },
        ),
      );
    },
  });

  public readonly isLoading = computed(() => this._helpLinks.isLoading());
  public readonly helpLinks = computed(() => this._helpLinks.value() ?? []);
}
